/*! ================================================
    |       THIS FILE HAS BEEN AUTOGENERATED       |
    |           FOR 24H-PFLEGE-CHECK.DE            |
    |                 DO NOT EDIT!                 |
    =============================================== */


// ====================================================
// Main Scripts File
//
'use strict';

// Called when DOM is fully loaded and generated
$(document).ready(function() {
    // Init Megamenu
    $(function() {
        cbpHorizontalMenu.init();
    });

   // ImageMap
   jQuery('img[usemap]').rwdImageMaps();

   var map = document.querySelectorAll('#imageMap area'), i = 0;
   for (i = 0; i < map.length; i++) {
      if (map[i].addEventListener) {
         map[i].addEventListener('touchstart', swap, false);
         map[i].addEventListener('mouseover', swap, false);
      }
   }

   function swap(ev) {
      var linkUrl = this.getAttribute('alt');
      document.querySelector('#Deutschlandkarte').setAttribute('src', linkUrl);
      return false;
   }

    // Slicksliders
    $('#slider-1, #slider-2, #slider-4').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        dots: true,
        prevArrow: '<button class="slick-prev"><i class="fa fa-angle-left fa-4x" aria-hidden="true"></i></button>',
        nextArrow: '<button class="slick-next"><i class="fa fa-angle-right fa-4x" aria-hidden="true"></i></button>',
        responsive: [
            {
                breakpoint: 891,
                settings: {
                    arrows: false
                }
            }
        ]
    });

    $('#slider-3').slick({
        autoplay: false,
        prevArrow: '<button class="slick-prev"><i class="fa fa-angle-left fa-4x" aria-hidden="true"></i></button>',
        nextArrow: '<button class="slick-next"><i class="fa fa-angle-right fa-4x" aria-hidden="true"></i></button>',
        responsive: [
            {
                breakpoint: 891,
                settings: {
                    arrows: false
                }
            }
        ]
    });

    initSearchMenu();

    function checkFormFields() {
        // find class 'has-error', if not found -> enable btn-next
        var e = $('#registration-form > .current').find('.has-error').length;
        if (e) {
            // console.log('errors');
            $('.form-navigation .btn-next').prop('disabled', true);
        } else {
            // console.log('no errors');
            $('.form-navigation .btn-next').prop('disabled', false);
        }
    }

    // Fragebogen
    // When Radio Is Clicked:
    $('.questionnaire-radio').click(function () {
        // Check Radio (In Case Click is outside of label)
        $(this).find('input').prop('checked', true);

        $(this).closest('.box-wrapper').find('.questionnaire-radio').removeClass('blue').addClass('lighten');
        $(this).closest('.box-wrapper').removeClass("has-error").find('.invalid-message').remove();
        $(this).removeClass('lighten').addClass('blue');

        checkFormFields();
    });

    $("input[type!='radio']").keypress(function(event) {
        if(event.keyCode == 13) {
            event.preventDefault();
            return false;
        }
    });

    $("input[type!='radio']").keyup(function() {
        checkFormFields();
    });

    $('select').change(function() {
        checkFormFields();
    });

    $(function () {
        var $sections = $('#registration-form fieldset');
        var stepPercentage = 0;
        var formError = $(".global-error").length;
        var emailError = false;

        if ( formError ) {
            $('.global-error ul > li').each(function(i, item) {
                if ($(item).text().startsWith("Ihre eMail-Adresse ist")) {
                    emailError = true;
                }
            });
        }

        function navigateTo(index) {
            // Mark the current section with the class 'current'
            $sections
                .removeClass('current')
                .eq(index)
                .addClass('current');
            // Show only the navigation buttons that make sense for the current section:
            $('.form-navigation .btn-previous').toggle(index > 0);
            var atTheEnd = index >= $sections.length - 1;
            $('.form-navigation .btn-next').toggle(!atTheEnd);
            $('.form-navigation [type=submit]').toggle(atTheEnd);

            // set button IDs for specific step (tracking)
            $('.form-navigation .btn-next').attr('id', 'formStep' + (index + 2));
            $('.form-navigation .btn-previous').attr('id', 'formStep' + index + 'b');

            // dynamic content for 1 page landing page
            if (window.location.pathname == "/go/24-stunden-pflege-2/") {
                $('.testimonials').toggle(index === 0);
                $('.stats').toggle(index === 0);
                $('.partners').toggle(index === 0);
                $('.faq').toggle(index === 0);
                $('.concept').toggle(index === 0);
                $('.bottom').toggle(index === 0);
                $('#bottomcontent').toggle(index === 7);
            } else {
                // remove content under form if we show other than first page
                $('#bottomcontent').toggle(index <= 0);
            }

            var stepCounter = document.querySelector('.progress-step')
			if (stepCounter) {
				stepCounter.innerHTML = (curIndex()+1) + '/' + $sections.length;
				stepPercentage = ((curIndex()+1)/$sections.length)*100;
				$('.progress-bar').css('width', stepPercentage + '%');
				
				if ( index > 0 && !formError) { // wenn nicht 1. Schritt, dann passend scrollen (ueber Einleiter-Text hinweg)
					var scrollPos = $('#registration-form').parent().offset().top - 70;
					var props = {};
					props.scrollTop = scrollPos;
					$('body,html').animate(props, 800);
				}
			}
        }

        // remove Hinweis on 1 page landing page
        if (window.location.pathname == "/go/24-stunden-pflege-2/") {
            $('#bottomcontent').hide();
        }

        function curIndex() {
            // Return the current index by looking at which section has the class 'current'
            return $sections.index($sections.filter('.current'));
        }

        // Previous button is easy, just go back
        $('.form-navigation .btn-previous').click(function() {
            navigateTo(curIndex() - 1);
        });

        // Next button goes forward if current block validates
        $('.form-navigation .btn-next').click(function() {
            $('.registration-form').parsley({
                errorClass: "has-error",
                successClass: 'has-success',
                errorsContainer: function(el) {
                    return el.$element.closest('.box-wrapper');
                },
                classHandler: function(el) {
                    if(el.$element.is('input[type="radio"]')) {
                        return el.$element.closest('.box-wrapper');
                    }
                    else {
                        return el.$element.closest('.form-group');
                    }
                },
                trigger: 'change',
                errorsWrapper: '<div class="invalid-message"></div>',
                errorTemplate: '<span></span>'
            }).whenValidate({
                group: 'block-' + curIndex()
            }).done(function() {
                // if (curIndex() == "6") {
                //     var time = Math.floor(Math.random() * 5000) + 2000;
                //     $('.form-box').css('opacity', 0.35);
                //     $('.loading-animation').addClass('show');
                //     window.setTimeout(function() {
                //         $('.loading-animation').removeClass('show');
                //         $('.form-box').css('opacity', '');
                //         navigateTo(curIndex() + 1);
                //     }, time);
                //     $('.btn-next').attr('disable', 'disable');
                // } else {
                    navigateTo(curIndex() + 1);
                // }
            });
        });

        $('.registration-form').parsley().on('form:error', function() {
            // console.log('form:error');
            $('.form-navigation .btn-next').prop('disabled', true);
        })

        // Prepare sections by setting the `data-parsley-group` attribute to 'block-0', 'block-1', etc.
		$sections.each(function(index, section) {
            $(section).find(':input').attr('data-parsley-group', 'block-' + index);
        });

        if ( formError ) {
            // select all checked radios on validation error / page reload
            $("input[type=radio]:checked").parents(".questionnaire-radio").addClass("blue").removeClass("lighten");
            $("input[type=radio]:not(:checked)").parents(".questionnaire-radio").addClass("lighten").removeClass("blue");

            if( emailError ) {
                var pel = $('#inputEMail').parsley({
                    errorClass: 'has-error',
                    errorsWrapper: '<div class="invalid-message"></div>',
                    errorTemplate: '<span></span>',
                    errorsContainer: function(el) {
                        return el.$element.closest('.box-wrapper');
                    },
                    classHandler: function(el) {
                        return el.$element.closest('.form-group');
                    }
                });
                pel.addError('emailError', {
                    message: 'Die Eingabe muss eine gÃ¼ltige E-Mail-Adresse sein.'
                });
            }
            // goto last step on error
            navigateTo(7);
        } else {
            navigateTo(0); // Start at the beginning
        }

        // Prepare DateTimePicker (used in form.ftl)
        $('.datepicker').datetimepicker({
        		locale: 'de',
            format: 'L',
            	minDate: moment().add(7, 'd'),
            	maxDate: moment().add(6, 'M'), // 6 mon weiter
                ignoreReadonly: true,
            	icons: {
            		time: 'fa fa-clock-o',
            		date: 'fa fa-calendar',
            		up: 'fa fa-chevron-circle-up',
            		down: 'fa fa-chevron-circle-down',
            		previous: 'fa fa-chevron-circle-left',
            		next: 'fa fa-chevron-circle-right',
//            		today: 'glyphicon glyphicon-screenshot',
//            		clear: 'glyphicon glyphicon-trash',
            		close: 'fa fa-window-close'
            	}
        
        });
    });



    // Back-To-Top Button
    $(".back-to-top").hide(); // Der Button wird ausgeblendet
    // Funktion fÃ¼r das Scroll-Verhalten
    $(function () {
        $(window).scroll(function () {
            if ($(this).scrollTop() > 100) { // Wenn 100 Pixel gescrolled wurde
                $('.back-to-top').fadeIn();
            } else {
                $('.back-to-top').fadeOut();
            }
        });

        $('.back-to-top').click(function () { // Klick auf den Button
            $('body,html').animate({
                scrollTop: 0
            }, 800);
            return false;
        });
    });

    $('body,html').bind('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove', function (e) {
        if (e.which > 0 || e.type == "mousedown" || e.type == "mousewheel" || e.type == "wheel" || e.type == "touchmove") {
            $('html,body').stop();
        }
    });

});

// Searchmenu
function initSearchMenu(){
    $('.cbp-hrmenu-title.search').on('click', function () {
        var dropdownSearch = $('.nav-right-dropdown');
        if (dropdownSearch.hasClass('open')) {
            dropdownSearch.removeClass('open');
        } else {
            dropdownSearch.addClass('open');
            dropdownSearch.find('input').focus();
        }
    });
    
    // close menue if it looses focus. but only if nothing was entered yet.
    $('.nav-right-dropdown').on( "focusout", function() {
    		var value = $('.nav-right-dropdown').find('input').val();
    		if ( !value ) {
    			// no value was entered; we can safely close the menue.
    			$('.nav-right-dropdown').removeClass('open');
    		}
    });
}

// Megamenu
var cbpHorizontalMenu = (function() {

    var $listItems = $('#cbp-hrmenu > li'),
        $menuItems = $listItems.children('a'),
	$subPanels = $('#cbp-hrmenu div.cbp-hrsub'),
        $body = $('body'),
        current = -1; 

    function init(reload) {

	function reload() {
	    if($menuItems) $menuItems.unbind('mouseenter', open);
	    if($subPanels) $subPanels.unbind('mouseleave', close);

            $listItems = $('#cbp-hrmenu > li');
            $menuItems = $listItems.children('a');
            $subPanels = $('#cbp-hrmenu div.cbp-hrsub');
            $body = $('body');
            current = -1;
   	}

	if (reload) {
	    reload();
	}
	
	$menuItems.on('mouseenter', open );	
	$subPanels.on('mouseleave', close);
        $listItems.on('click', function( event ) {
            event.stopPropagation();
        });
    }

    function open(event) {
	
	if(current !== -1) {
            $listItems.eq( current ).removeClass('cbp-hropen');
        }

        var $item = $(event.currentTarget).parent('li'),
            idx = $item.index();

        if(current === idx) {
			if(!$item.hasClass('cbp-hropen')){
				$item.addClass('cbp-hropen');
			}
        //    $item.removeClass('cbp-hropen');
        //    current = -1;
        }
        else {
            $item.addClass('cbp-hropen');
            current = idx;
            //$body.off('click').on('click', close );
        }
    }

    function close(event) {
        $listItems.eq( current ).removeClass('cbp-hropen');
        current = -1;
    }
    return { init : init };

})();



// Parsley deutsche Sprache
Parsley.addMessages('de', {
    defaultMessage: "Die Eingabe scheint nicht korrekt zu sein.",
    type: {
        email:        "Die Eingabe muss eine gÃ¼ltige E-Mail-Adresse sein.",
        url:          "Die Eingabe muss eine gÃ¼ltige URL sein.",
        number:       "Die Eingabe muss eine Zahl sein.",
        integer:      "Die Eingabe muss eine Zahl sein.",
        digits:       "Die Eingabe darf nur Ziffern enthalten.",
        alphanum:     "Die Eingabe muss alphanumerisch sein."
    },
    notblank:       "Die Eingabe darf nicht leer sein.",
    required:       "Dies ist ein Pflichtfeld.",
    pattern:        "Die Eingabe scheint ungÃ¼ltig zu sein.",
    min:            "Die Eingabe muss grÃ¶Ãer oder gleich %s sein.",
    max:            "Die Eingabe muss kleiner oder gleich %s sein.",
    range:          "Die Eingabe muss zwischen %s und %s liegen.",
    minlength:      "Die Eingabe ist zu kurz. Es mÃ¼ssen mindestens %s Zeichen eingegeben werden.",
    maxlength:      "Die Eingabe ist zu lang. Es dÃ¼rfen hÃ¶chstens %s Zeichen eingegeben werden.",
    length:         "Die LÃ¤nge der Eingabe ist ungÃ¼ltig. Es mÃ¼ssen zwischen %s und %s Zeichen eingegeben werden.",
    mincheck:       "WÃ¤hlen Sie mindestens %s Angaben aus.",
    maxcheck:       "WÃ¤hlen Sie maximal %s Angaben aus.",
    check:          "WÃ¤hlen Sie zwischen %s und %s Angaben.",
    equalto:        "Dieses Feld muss dem anderen entsprechen."
});

Parsley.setLocale('de');


	/**
	 * Called when everything is loaded (html, js, images and css files)
	 */
	jQuery(window).on('load', function() {
	   jQuery('.sameheight .boxed, #content .boxed .boxcontent .advantage').matchHeight(true);
	});

	// Blog
	var toggleCollapse = function(element) {
	   element = jQuery(element);
	   element.find('i').toggleClass('fa-chevron-up');
	   element.find('i').toggleClass('fa-chevron-down');
	   jQuery(element.attr('href')).collapse('toggle');
	}; 
	
	//Agencylist
	var showNews;
	jQuery('.listofagencies .news, .listofagencies .news a').click(function(e) {
	   e.preventDefault();
	   showNews = jQuery(this).index() + 1;
	   jQuery('.updatelist').hide();
	   jQuery('#listno' + showNews).show();
	});
	jQuery('.listofagencies .news, .listofagencies .news a').mouseover(function(e) {
	   e.preventDefault();
	   showNews = jQuery(this).index() + 1;
	   jQuery('.updatelist').hide();
	   jQuery('#listno' + showNews).show();
	});
	
	// Tooltips
	var  tooltips = jQuery('[data-toggle="tooltip"]');
	if (tooltips) {
		tooltips.tooltip(); 
	}
	
	// Popover
	jQuery('[data-toggle="popover"]').popover();
	
	// Accordion
	jQuery('#accordion').find('.panel-title a').click(function() {
		jQuery('#accordion .panel-heading').removeClass('activePanel');
		jQuery(this).parent().parent().addClass('activePanel');
	});


if (window.location.pathname == "/angebot-anfordern/") {
    $("#footerMobileCTAStickyBtn").removeClass("visible-xs-block");
    $("#footerMobileCTAStickyBtn").addClass("hidden");
    $("#footerCTABtn").addClass("hidden");
} else {
    $("#footerMobileCTAStickyBtn").addClass("visible-xs-block");
    $("#footerMobileCTAStickyBtn").removeClass("hidden");
}

// scrolls to the form
function gotoForm() {
    var scrollPos = $('#registration-form').parent().offset().top - 70;
    var props = {};
    props.scrollTop = scrollPos;
    $('body,html').animate(props, 800);
}

   // Image Gallery
jQuery('.thumbnailwrap img').click(function() {
    var urltochange = jQuery(this).attr('src');
    jQuery('#changeit').attr({'src': urltochange});
 });

// ====================================================
// File for small inline js plugins
//
'use strict';

// Avoid `console` errors in browsers that lack a console.
(function() {
    var method;
    var noop = function () {};
    var methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeStamp', 'trace', 'warn'
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});

    while (length--) {
        method = methods[length];

        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }
}());

// Place any small inline jQuery/helper plugins in here.
$(document).ready(function() {

	   // Bewertungen anlegen
	   $.each( $(".starInput"), function( k, v ) {
	      var captElemId = $(v).attr('id') + "_capt";
	      $(v).rating({
	         captionElement: "#" + captElemId,
	         defaultCaption: "{rating}",
	         clearCaption: "bitte wÃ¤hlen",
	         starCaptions: {
	             0.5: '0,5 Sterne',
	             1:   '1 Stern',
	             1.5: '1,5 Sterne',
	             2:   '2 Sterne',
	             2.5: '2,5 Sterne',
	             3:   '3 Sterne',
	             3.5: '3,5 Sterne',
	             4:   '4 Sterne',
	             4.5: '4,5 Sterne',
	             5:   '5 Sterne'
	         },
	         starCaptionClasses: {
	             0.5: '',
	             1:   '',
	             1.5: '',
	             2:   '',
	             2.5: '',
	             3:   '',
	             3.5: '',
	             4:   '',
	             4.5: '',
	             5:   ''
	         },
	         clearCaptionClass: ''
	      });
	   });

	   if ($('#reviewTitle').length) {
	      $('#reviewTitleLength').text( $('#reviewTitle').val().length );
	      $('#reviewTitle').keyup(function (e) {
	          $('#reviewTitleLength').text( $('#reviewTitle').val().length );
	      });

	      $('#reviewTextLength').text( $('#reviewText').val().length );
	      $('#reviewText').keyup(function (e) {
	          $('#reviewTextLength').text( $('#reviewText').val().length );
	      });
	   }


	   // Neuen Anbieter registrieren
	   $("input[type=radio][name=registerUser]").change(function() {
	        if (this.value == "N") {
	           $("#compData").show("slow");
	           $("#submitDiv").show("slow");
	           $("#persData").hide("slow");
	        }
	        else if (this.value == "Y") {
	           $("#persData").show("slow");
	        }
	    });

	});
